const TIME_OUT = 250;
const body = document.querySelector("body");
const popupContainer = document.querySelector("#popup-container");

const popupOpenTriggers = document.querySelectorAll(".popup-open-js");
const popupCloseTriggers = document.querySelectorAll(".popup-close-js");
const lockPaddingElements = document.querySelectorAll(".lock-padding");
let unlock = true;

if (popupContainer) {
  popupContainer.classList.remove("hidden");
}

function lockBody() {
  body.style.paddingRight = `${window.innerWidth - document.documentElement.clientWidth}px`;
  body.classList.add("lock");
  unlock = false;

  setTimeout(() => {
    unlock = true;
  }, TIME_OUT);
}

function unlockBody() {
  if (lockPaddingElements.length > 0) {
    lockPaddingElements.forEach(e => {
      e.style.paddingRight = "0px";
    });
  }

  body.style.paddingRight = "0px";
  body.classList.remove("lock");

  unlock = false;

  setTimeout(() => {
    unlock = true;
  }, TIME_OUT);
}

function closePopup(popupId) {
  if (unlock) {
    const closedPopup = document.getElementById(popupId);

    if (closedPopup) {
      closedPopup.classList.remove("is-active");
      setTimeout(() => {
        unlockBody();
      }, TIME_OUT);
    }
  }
}

function onEscPress(event) {
  if (event.key === "Escape" || event.keyCode === 27) {
    const currentActivePopup = document.querySelector(".popup-js.is-active");
    const popupId = currentActivePopup?.getAttribute("id");

    closePopup(popupId);
  }
}

function openPopup(popupId) {
  const currentActivePopup = document.querySelector(".popup-js.is-active");
  const currentActivePopupId = currentActivePopup?.getAttribute("id");

  if (currentActivePopupId) {
    closePopup(popupId);
  }

  const openedPopup = document.getElementById(popupId);

  if (!openedPopup) return;

  lockBody();
  document.addEventListener("keydown", onEscPress);

  openedPopup.classList.add("is-active");

  openedPopup.addEventListener("click", event => {
    if (!event.target.closest(".popup-content-js")) {
      closePopup(popupId);
    }
  });
}

function onPopupOpenTrigger(event) {
  event.preventDefault();
  const popupId = this.dataset.popup;

  if (popupId) {
    openPopup(popupId);
  }
}

function onPopupCloseTrigger(event) {
  event.preventDefault();

  const currentActivePopup = this.closest(".popup-js");
  const popupId = currentActivePopup?.getAttribute("id");

  if (popupId) {
    closePopup(popupId);
  }
}

if (popupOpenTriggers.length > 0) {
  popupOpenTriggers.forEach(popupOpenTrigger => {
    popupOpenTrigger.addEventListener("click", onPopupOpenTrigger);
  });
}

if (popupCloseTriggers.length > 0) {
  popupCloseTriggers.forEach(popupCloseTrigger => {
    popupCloseTrigger.addEventListener("click", onPopupCloseTrigger);
  });
}

window.openPopup = openPopup;
window.closePopup = closePopup;
